import { ArrowLeftOutlined } from '@ant-design/icons';
import { Input, ScrollArea, Stepper } from '@mantine/core';
import { Search } from '@material-ui/icons';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { TextField } from '@mui/material';
import { useFormik } from 'formik';
import { isPending } from 'functions';
import { getCityCodeServ } from 'model/services/LoyaltyGiftService';
import React, { useEffect, useState } from 'react';
import { formatTimeString, format_curency } from 'utils';
import { phoneRegexVN, regexEmail } from 'utils/regex';
import * as yup from 'yup';
import ConfirmPopup from '../../ConfirmPopup';

const validationSchema = yup.object({
  name: yup.string().required('Vui lòng nhập họ & tên người nhận!'),
  phoneNumber: yup
    .string()
    .matches(phoneRegexVN, 'Số điện thoại không hợp lệ')
    .required('Vui lòng nhập số điện thoại'),
  detailLocation: yup.string().required('Vui lòng nhập chi tiết địa chỉ nhận hàng'),
  location: yup.string().required('Vui lòng nhập địa chỉ nhận hàng'),
  email: yup.string().matches(regexEmail, 'Email không hợp lệ'),
});
const defaultLocationShip = {
  city: {
    value: '',
    label: '',
  },
  province: {
    value: '',
    label: '',
  },
  village: {
    value: '',
    label: '',
  },
};

const PhysicalGift = ({ data, quantity, status, handleChangeStatus, handleSubmitChangeGift }) => {
  const { isOpen, isLoading } = status;
  const { date, month, year } = formatTimeString(new Date().toISOString());

  const [stepChooseLocation, setStepChooseLocation] = useState(0);
  const [isOpenLocationPick, setIsOpenLocationPick] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [locationData, setLocationData] = useState([]);
  const [locationSeach, setLocationSearch] = useState([]);
  const [search, setSearch] = useState('');
  const [locationShip, setLocationShip] = useState(defaultLocationShip);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: '',
      phoneNumber: '',
      detailLocation: '',
      email: '',
      note: '',
      location: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {},
  });

  const handleClose = () => {
    handleChangeStatus((prev) => {
      return {
        ...prev,
        isOpen: false,
      };
    });
  };
  const handleSetLocation = (value) => {
    if (stepChooseLocation == 0) {
      setLocationShip((prev) => {
        return {
          ...prev,
          city: value,
        };
      });
      setStepChooseLocation(1);
    } else if (stepChooseLocation == 1) {
      setLocationShip((prev) => {
        return {
          ...prev,
          province: value,
        };
      });
      setStepChooseLocation(2);
    } else if (stepChooseLocation == 2) {
      setLocationShip((prev) => {
        return {
          ...prev,
          village: value,
        };
      });
      formik.setFieldValue(
        'location',
        `${value.label}, ${locationShip.province.label}, ${locationShip.city.label}`
      );
      setStepChooseLocation(3);
      setIsOpenLocationPick(false);
    }
  };
  const handleConfirmPopup = () => {
    const { values } = formik;
    const payload = {
      giftCode: data.giftInfor.code,
      date: new Date().toISOString(),
      description: JSON.stringify({
        fullName: values.name,
        phone: values.phoneNumber,
        shipAddress: values.detailLocation + ', ' + values.location,
        email: values.email,
        note: values.note,
      }),
    };
    handleSubmitChangeGift(payload);
  };
  const handleChooseLocation = () => {
    setIsOpenLocationPick(true);
    setLocationShip(defaultLocationShip);
    setStepChooseLocation(0);
  };

  useEffect(() => {
    if (isOpenLocationPick) {
      setIsLoading2(true);
      getCityCodeServ({ cityCode: '' }).then((res) => {
        setIsLoading2(false);
        setLocationData(res.obj);
      });
    }
  }, [isOpenLocationPick]);

  useEffect(() => {
    if (stepChooseLocation == 1) {
      setIsLoading2(true);
      getCityCodeServ({ cityCode: locationShip.city.value }).then((res) => {
        setIsLoading2(false);
        setLocationData(res.obj);
      });
    } else if (stepChooseLocation == 2) {
      setIsLoading2(true);
      getCityCodeServ({ cityCode: '', townCode: locationShip.province.value }).then((res) => {
        setIsLoading2(false);
        setLocationData(res.obj);
      });
    }
    setSearch('');
  }, [stepChooseLocation]);

  // search
  useEffect(() => {
    if (locationData.length > 0) {
      const filter = locationData.filter((i) =>
        i.label.toLowerCase().includes(search.toLowerCase())
      );
      setLocationSearch(filter);
    }
  }, [search]);

  useEffect(() => {
    setLocationSearch(locationData);
  }, [locationData]);

  useEffect(() => {
    return () => {
      handleChangeStatus({
        isOpen: false,
        isSuccess: false,
        isFail: false,
        isLoading: false,
        resson: '',
      });
    };
  }, []);

  const processBar = isPending(isLoading2 || isLoading);

  return (
    <>
      <div
        className={`absolute transition-all ${
          isOpen ? 'top-0' : 'top-full'
        } z-[200] h-full w-full bg-white py-5`}
      >
        {processBar}
        <div className='flex w-full grow items-center justify-between px-4'>
          <div className='flex items-center'>
            <ArrowLeftOutlined
              style={{
                fontSize: '20px',
                color: '#000',
              }}
              onClick={handleClose}
            />
            <div className='grow'>
              <span className='mx-2 line-clamp-1 font-averta-bold text-18px'>
                {data.giftInfor.name}
              </span>
            </div>
          </div>
          <div className='mr-0 w-fit lg:mr-16'>
            <div className='flex w-full items-center'>
              <img className='mx-2' src='/assets/images/loyalty/freeship.svg' alt='' />
              <div className='hidden w-fit rounded-4px border border-008BD2 bg-F2FAFF md:flex'>
                <p className='whitespace-nowrap px-5 py-2 font-averta-bold text-24px leading-18px text-0090F0'>
                  {format_curency(data.giftInfor.requiredCoin)} điểm
                </p>
                {/* <p className='text-14px text-7B7B7B px-2 py-2 border-l border-008BD2 whitespace-nowrap'>
                  Áp dụng đến3:{' '}
                  <span className='text-0090F0 font-roboto-bold'>
                    {date}/{month}/{year}
                  </span>
                </p> */}
              </div>
            </div>
          </div>
        </div>
        {/* info for shipping */}
        <form
          autoComplete='off'
          className='h-full overflow-y-auto px-4 lg:h-[504px]'
          onSubmit={formik.handleSubmit}
        >
          <TextField
            size='small'
            name='name'
            rows={1}
            label='Họ & tên người nhận *'
            variant='outlined'
            className='w-full lg:w-[calc(50%_-_12px)]'
            sx={{
              margin: '32px 0',
              '& .MuiFormLabel-root': {
                fontSize: '14px',
                color: '#9D9D9D',
              },
            }}
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
          />
          <p className='mb-3 font-roboto-medium text-16px'>
            Địa chỉ *
            <span className='font-roboto-medium text-red-600'>
              (Vui lòng nhập địa chỉ trước sáp nhập)
            </span>
          </p>
          <div className='block text-[#9D9D9D] lg:flex'>
            <div
              className={`flex h-[40px] w-full items-center border lg:w-1/2 ${
                formik.touched.location && Boolean(formik.errors.location)
                  ? 'border-[#d23f2f]'
                  : 'border-[#0000003b]'
              } relative mb-6 mr-6 rounded-[4px] lg:mb-0`}
              onClick={handleChooseLocation}
            >
              <TextField
                size='small'
                label='Thành phố / Quận huyện / Phường-xã'
                variant='outlined'
                className='w-full'
                sx={{
                  '& .MuiFormLabel-root': {
                    fontSize: '14px',
                    color: '#9D9D9D',
                    background: '#fff',
                    padding: '0 4px',
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                    outline: 'none',
                  },
                  '& .MuiFormHelperText-root': {
                    position: 'absolute',
                    zIndex: '30',
                    bottom: '-22px',
                  },
                }}
                value={`${
                  stepChooseLocation == 3
                    ? `${locationShip.village.label} - ${locationShip.province.label} - ${locationShip.city.label}`
                    : ''
                }`}
                error={formik.touched.location && Boolean(formik.errors.location)}
                helperText={formik.touched.location && formik.errors.location}
              />
              <ArrowDropDownIcon color='inherit' className='mr-2' />
            </div>
            <TextField
              name='detailLocation'
              size='small'
              label='Địa chỉ chi tiết (số nhà - tên đường)'
              variant='outlined'
              className='w-full lg:w-1/2'
              sx={{
                '& .MuiFormLabel-root': {
                  fontSize: '14px',
                  color: '#9D9D9D',
                },
              }}
              value={formik.values.detailLocation}
              onChange={formik.handleChange}
              error={formik.touched.detailLocation && Boolean(formik.errors.detailLocation)}
              helperText={formik.touched.detailLocation && formik.errors.detailLocation}
            />
          </div>
          <div className='my-5 h-3 w-full bg-F1F4FB'></div>
          <div className='flex'>
            <TextField
              name='phoneNumber'
              size='small'
              rows={1}
              label='Số điện thoại *'
              variant='outlined'
              className='w-1/2'
              sx={{
                marginRight: '24px',
                '& .MuiFormLabel-root': {
                  fontSize: '14px',
                  color: '#9D9D9D',
                },
              }}
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
              helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
            />
            <TextField
              name='email'
              label='Email'
              size='small'
              variant='outlined'
              className='w-1/2'
              sx={{
                '& .MuiFormLabel-root': {
                  fontSize: '14px',
                  color: '#9D9D9D',
                },
              }}
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
          </div>
          <TextField
            name='note'
            size='small'
            label='Thông tin khác'
            variant='outlined'
            multiline
            maxRows={6}
            rows={4}
            className='w-full'
            sx={{
              margin: '25px 0 0 0',
              '& .MuiFormLabel-root': {
                fontSize: '14px',
                color: '#9D9D9D',
              },
            }}
            value={formik.values.note}
            onChange={formik.handleChange}
          />
          <div className='mx-auto w-fit'>
            <button
              type='button'
              onClick={() => {
                formik.submitForm().then(() => {
                  if (
                    Object.keys(formik.errors).length <= 0 &&
                    formik.values.name.trim().length > 0
                  ) {
                    setIsOpenConfirm(true);
                  }
                });
              }}
              className={`${
                isOpenConfirm ? 'invisible' : 'visible'
              } mx-auto my-4 w-fit rounded-md bg-gradient-blue px-[130px] py-3 uppercase text-white`}
            >
              Đổi quà
            </button>
          </div>
          <p className='text-center font-roboto-regular text-12px italic text-7B7B7B'>
            <span className='font-bold text-[#D81221]'>* Chú ý:</span> Urbox - Đối tác cung cấp quà
            tặng của BVNT sẽ gọi điện để <span className='font-bold'>XÁC NHẬN LẠI</span> thông tin
            giao quà với Quý khách hàng trước khi vận chuyển.
          </p>
        </form>
        <ConfirmPopup
          isOpen={isOpenConfirm}
          handleClose={() => setIsOpenConfirm(false)}
          handleSubmit={handleConfirmPopup}
          quantity={quantity}
          name={data.giftInfor.name}
          point={data.giftInfor.requiredCoin}
        />
      </div>
      {/* choose location for ship */}
      <div
        className={`absolute z-[300] h-full w-full bg-white py-5 transition-all ${
          isOpenLocationPick ? 'top-0' : 'top-full'
        }`}
      >
        <div className='flex w-full grow flex-col justify-between px-4 lg:flex-row lg:items-center'>
          <div className='flex items-center'>
            <ArrowLeftOutlined
              style={{
                fontSize: '20px',
                color: '#000',
              }}
              onClick={() => {
                setIsOpenLocationPick(false);
                setLocationShip(defaultLocationShip);
                formik.setFieldValue('location', '');
              }}
            />
            <div className='grow'>
              <span className='mx-2 line-clamp-1 font-averta-bold text-18px'>
                Địa chỉ nhận:{' '}
                {stepChooseLocation === 1
                  ? locationShip.city.label
                  : stepChooseLocation === 2
                  ? locationShip.city.label + '/' + locationShip.province.label
                  : ''}
              </span>
            </div>
          </div>
          <div className='mt-4 w-fit'>
            <Stepper
              size='xs'
              active={stepChooseLocation}
              classNames={{
                root: 'w-[300px]',
                stepIcon: 'w-5 h-5 min-w-[20px] text-[12px] mx-auto font-roboto-regular',
                stepCompletedIcon: 'w-3 mx-auto',
                stepLabel: 'text-0090F0',
              }}
            >
              <Stepper.Step
                iconSize={10}
                label={`${stepChooseLocation === 0 ? 'Tỉnh/thành phố' : ''}`}
              ></Stepper.Step>
              <Stepper.Step
                iconSize={10}
                label={`${stepChooseLocation === 1 ? 'Quận/huyện' : ''}`}
              ></Stepper.Step>
              <Stepper.Step
                iconSize={10}
                label={`${stepChooseLocation === 2 ? 'Phường/xã' : ''}`}
              ></Stepper.Step>
            </Stepper>
          </div>
        </div>
        <div>
          <Input
            icon={<Search className='ml-4' />}
            className='my-5 w-full'
            classNames={{ input: 'rounded-none border-x-0 pl-10' }}
            placeholder='Tìm kiếm'
            onChange={(e) => setSearch(e.target.value)}
            value={search}
          />
          <div className='my-4'>
            <ScrollArea style={{ height: '450px', overflowY: 'scroll' }}>
              {locationSeach.length > 0
                ? locationSeach.map((i, index) => (
                    <p
                      onClick={() => handleSetLocation(i)}
                      key={index}
                      className='py-2 pl-6 font-roboto-regular text-14px hover:bg-0079c2 hover:text-white'
                    >
                      {i.label}
                    </p>
                  ))
                : null}
            </ScrollArea>
          </div>
        </div>
      </div>
    </>
  );
};

export default PhysicalGift;
